
import ReviewsSummary from './components/ReviewsSummary';

export default {
  i18nComponentKey: 'WidgetAddOnReviewsSummary.WidgetAddOnReviewsSummary',
  name: 'WidgetAddOnReviewsSummary',
  components: { ReviewsSummary }
};
